import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { UseContextPromotionColaborador } from "#promotions/contexts/ContextPromotionColaborador"
import { promotionDetailsIdFileIdDelete } from "#promotions/services/api"
import { Typography } from "@mui/material"
import { useCallback, useState } from "react"

export default function FileDialogDelete({ open, setOpen, data }) {
	const { refreshFiles } = UseContextPromotionColaborador()
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		refreshFiles()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(promotionDetailsIdFileIdDelete, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch({ id: data.promotion_detail, fileId: data.id })
	}, [fetch, data.promotion_detail, data.id])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [setOpen])

	return (
		<DialogMaster
			{...{
				title: `eliminar ${data?.name}`,
				setOpen,
				open,
				handleSubmit,
				disabled,
				onClose: handleClose,
			}}
		>
			<Typography variant="body1" textAlign={"center"}>
				¿Estás seguro de que deseas realizar esta acción? <br />
			</Typography>
			<Typography variant="body2" textAlign={"center"}>
				Esta acción es permanente y no se puede deshacer.
			</Typography>
		</DialogMaster>
	)
}
